import gazetteer, { CountryCodes } from '@bridebook/toolbox/src/gazetteer';

/**
 * This file is DEPRECATED.
 * All feature flags should be migrated to the gazetteer bucket system.
 * See the gazetteer/buckets/README.md file for more information.
 */

// Helpers
const { GB, DE, FR, IE, US, CA, AU, ZA, AT, CH, NG } = CountryCodes;

export const monetizedMarkets = gazetteer
  .getCountries({ monetized: true })
  .map((country) => country.id);

export const countriesWithVenueRecommendationsBanner = [GB];

export const countriesWithAdvice = [GB, DE, FR, IE, AT, CH, AU, CA, ZA];

export const marketsWithLandingPages = gazetteer
  .getMarkets({ blocked: false })
  .filter((market) => market.getLocaleFlags()?.public && market.hasAnyDirectory);

export const indexableMarkets = gazetteer
  .getMarkets({ blocked: false })
  .filter((market) => market.getLocaleFlags()?.indexable && market.hasAnyDirectory);

/**
 * Countries explicitly excluded from the signup dropdown.
 */
export const countriesExcludedFromSignup = [US];

export const countriesWithMultiEnquiryModal = [GB];

export const countriesWithApplyOnboardingFilterPreferencesToSearchResults = GB;

/**
 * Countries from where international weddings and enquiries to external countries are silently blocked.
 * This is an anti-spam measure.
 */
export const countriesWithBlockedExternalWeddings = [NG];

// [CMS FLAGS]

export const countriesWithGeneratedPriceEstimateViews = [GB]; // CMS
